// extracted by mini-css-extract-plugin
export default {"formBox":"ForgotPassword_formBox__LK8Wy","formContainer":"ForgotPassword_formContainer__hXaKt"};